

function Home() {
  return (
    <div className="home">
      <h1 id="name">
        ISAAC JENEMANN <br />
        <span id="creative">
          creative
        </span>
      </h1>
    </div>
  );
}

export default Home;
